import queryString from "query-string";
import { getUserFriendlyFederatedSignInError } from "../../../lib/auth";
import { useEffect, useState } from "react";
import type { Error } from "./useAuthErrors";

export default function useFederatedSigninErrors() {
  const [error, setError] = useState<Error | null>(null);
  useEffect(() => {
    const { federatedSignInError, errorDescription } = queryString.parse(
      location.search,
    );

    if (
      federatedSignInError &&
      !Array.isArray(federatedSignInError) &&
      errorDescription &&
      !Array.isArray(errorDescription)
    ) {
      setError(
        getUserFriendlyFederatedSignInError(
          federatedSignInError,
          errorDescription,
        ),
      );
    }
  }, []);

  const clearFederatedSignInError = () => {
    setError(null);
    window.history.replaceState(null, "", window.location.pathname);
  };

  return { error, clearFederatedSignInError };
}
